import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronLeft, FiChevronRight } = FiIcons;

const TokenUsageHistory = ({ usageRecords }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 10; // Reduced for better mobile view
  const pageCount = Math.ceil(usageRecords.length / recordsPerPage);

  const handleNext = () => {
    setCurrentPage((prev) => (prev + 1 < pageCount ? prev + 1 : prev));
  };

  const handleBack = () => {
    setCurrentPage((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
  };

  const startIndex = currentPage * recordsPerPage;
  const selectedRecords = usageRecords.slice(startIndex, startIndex + recordsPerPage);

  return (
    <div className="mt-4 border-t pt-4">
      <div className="space-y-3">
        {selectedRecords.map((record, index) => (
          <motion.div
            key={record.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
            className="flex justify-between items-center p-3 bg-white rounded-lg shadow-sm border"
          >
            <span className="text-sm font-medium text-gray-700 capitalize">{record.used_token_from || 'Unknown'}</span>
            <span className="text-sm font-bold text-green-600">{record.tokens_used.toLocaleString()}</span>
          </motion.div>
        ))}
      </div>
      {pageCount > 1 && (
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handleBack}
            disabled={currentPage === 0}
            className="p-2 bg-gray-200 rounded-full disabled:opacity-50 hover:bg-gray-300 transition"
          >
            <SafeIcon icon={FiChevronLeft} />
          </button>
          <span className="text-sm font-medium">
            Page {currentPage + 1} of {pageCount}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === pageCount - 1}
            className="p-2 bg-gray-200 rounded-full disabled:opacity-50 hover:bg-gray-300 transition"
          >
            <SafeIcon icon={FiChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default TokenUsageHistory;
